import { Component, OnInit } from '@angular/core';
import { UserDetailComponent } from '../user/user-detail/user-detail.component';
import { MainPageService } from '../service/main-page.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../shared/user.service';
import { MainPage } from '../../app/model/main-page.model';

@Component({
  providers: [UserDetailComponent],
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.css']
})
export class MainPageComponent implements OnInit {

  resultTable: MainPage[] = null;
  //resultModel = new MainPage (null,null,null,null,null);
  resultModel: MainPage = null
  userDetails: any = null;
  cols: any[];
  msgs: any[] = [];
  dataResults: MainPage[] = null;
  //dataResults: any[] = [{}];
  currentDate: Date = new Date();
  current: Date = new Date();
  date1: Date = new Date();
  date2: Date = new Date();
  date3: Date = new Date();
  dataTotals: any = null;

  constructor(private dataService: MainPageService, private userService: UserService) { }

  ngOnInit() {
    this.date1 = new Date(this.date1.getFullYear(), this.current.getMonth() - 1, 1)
    this.date2 = new Date(this.date2.getFullYear(), this.current.getMonth() - 2, 1)
    this.date3 = new Date(this.date3.getFullYear(), this.current.getMonth() - 3, 1)
    this.userService.getUserClaims().subscribe((result: any) => {
      this.userDetails = result;
      if (this.userDetails.ClientRoleSupport || this.userDetails.ClientRoleAdministration  || this.userDetails.ClientRoleSemiAdministrator) {
        //this.roleAdministration();
        this.getDashboardByAdministratorAndSupport();
      }
      // else if (this.userDetails.ClientRoleContactMan || this.userDetails.ClientRoleCustomer) {
      //   this.getDetails();
      //   //this.roleContactMan();
      // }
      else {
        this.getDashboardByContactManAndCustomer();
        this.GetLastTotalsContactManAndCustomer();
      }
      // else if (this.userDetails.ClientRoleCustomer) {
      //   this.roleCustomer();
      // }
    },
      (err: HttpErrorResponse) => {
        this.userDetails = null;
        this.showMessage('error', '', 'שגיאה בקבלת הרשאות');
      });

    this.cols = [
      { field: 'IdentityNumber', header: 'ח.פ. מעסיק' },
      { field: 'CustomerName', header: 'שם מעסיק' },
      { field: 'NumberOfFiles', header: 'מספר קבצים' }
    ];
  }

  roleAdministration(): void {
    this.dataService.getRoleAdministration().subscribe((result: MainPage) => {
      this.resultModel = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'שגיאה בקבלת נתונים');
        this.resultModel = null;
      });
  }

  roleContactMan(): void {
    this.dataService.getRoleContactMan().subscribe((result: MainPage[]) => {
      this.resultTable = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'שגיאה בקבלת נתונים');
        this.resultTable = null;
      });
  }

  roleCustomer(): void {
    this.dataService.getRoleCustomer().subscribe((result: MainPage) => {
      this.resultModel = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'שגיאה בקבלת נתונים');
        this.resultModel = null;
      });
  }

  isExistAtLeastOneReport(item, i): any {
    if (item == null) return false;
    if (item[i] == null) return false;
    if (item[i].SUM_DIVUACH == null && item[i].SUM_NIKLAT == null && item[i].SUM_NIDHA == null && item[i].SUM_HEMESH_TIPUL == null) return false;
    return true;
  }

  getMonthName(m): any {
    let mont = '';
    switch (m.getMonth() + 1) {
      case 1:
        mont = 'ינואר';
        break;
      case 2:
        mont = 'פברואר';
        break;
      case 3:
        mont = 'מרץ';
        break;
      case 4:
        mont = 'אפריל';
        break;
      case 5:
        mont = 'מאי';
        break;
      case 6:
        mont = 'יוני';
        break;
      case 7:
        mont = 'יולי';
        break;
      case 8:
        mont = 'אוגוסט';
        break;
      case 9:
        mont = 'ספטמבר';
        break;
      case 10:
        mont = 'אוקטובר';
        break;
      case 11:
        mont = 'נובמבר';
        break;
      case 12:
        mont = 'דצמבר';
        break;
     
    }   
    return mont;
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  getDashboardByContactManAndCustomer() {
    this.dataService.getContactManAndCustomer().subscribe((result: any) => {
      this.dataResults = new Array<MainPage>();
      this.dataResults = result;
      for (let i = 0; i < this.dataResults.length; i++) {
        if (i === 0 && this.dataResults[i] === null) {
          this.currentDate = new Date(this.current.getFullYear(), this.current.getMonth() + 1, 0);
        } else if (i === 1 && this.dataResults[i] === null) {
          this.date1 = new Date(this.date1.getFullYear(), this.date1.getMonth() + 1, 0);
        } else if (i === 2 && this.dataResults[i] === null) {
          this.date2 = new Date(this.date2.getFullYear(), this.date2.getMonth() + 1, 0);
        } else if (i === 3 && this.dataResults[i] === null) {
          this.date3 = new Date(this.date3.getFullYear(), this.date3.getMonth() + 1, 0);
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'שגיאה בקבלת נתונים');
      });
  }

  GetLastTotalsContactManAndCustomer() {
    this.dataService.getLastTotalsContactManAndCustomer().subscribe((result: any) => {
      this.dataTotals = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'שגיאה בקבלת נתונים');
      });
  }

  getDashboardByAdministratorAndSupport() {
    this.dataService.getAdministratorAndSupport().subscribe((result: any) => {
      this.dataResults = new Array<MainPage>();
      this.dataResults = result;
      for (let i = 0; i < this.dataResults.length; i++) {
        if (i === 0 && this.dataResults[i] === null) {
          this.currentDate = new Date(this.current.getFullYear(), this.current.getMonth() + 1, 0);
        } else if (i === 1 && this.dataResults[i] === null) {
          this.date1 = new Date(this.date1.getFullYear(), this.date1.getMonth() + 1, 0);
        } else if (i === 2 && this.dataResults[i] === null) {
          this.date2 = new Date(this.date2.getFullYear(), this.date2.getMonth() + 1, 0);
        } else if (i === 3 && this.dataResults[i] === null) {
          this.date3 = new Date(this.date3.getFullYear(), this.date3.getMonth() + 1, 0);
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'שגיאה בקבלת נתונים');
      });
  }
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/main-page/main-page.component.ts